import { cn } from "../lib/utils"
import { Title } from "./Title"
import { Paragraph } from "./Paragraph"

export const ActivitiesGroup = ({ title, activities }) => (
  <div className="flex flex-col rounded-3xl px-8">
    <div className="flex items-center justify-center rounded-t-3xl bg-brand p-4">
      <h2 className="text-2xl font-bold text-white">{title}</h2>
    </div>
    <div className="rounded-b-3xl bg-white px-4">
      <div
        className={cn(
          "mx-auto flex w-fit flex-col items-center justify-center md:grid md:gap-4",
          activities.length <= 3
            ? activities.length === 3
              ? "md:grid-cols-3"
              : "md:grid-cols-1"
            : "md:grid-cols-4",
        )}
      >
        {activities.map((activity, index) => (
          <ActivityItem key={index} {...activity} />
        ))}
      </div>
    </div>
  </div>
)

export const ActivityItem = ({ title, description, image }) => (
  <div className="m-1 flex flex-col items-center justify-center rounded-3xl p-4">
    <img src={image} alt={title} className="mb-3 h-24 w-24" />
    <Title className="text-black text-xl">{title}</Title>
    <Paragraph className="text-center text-sm">{description}</Paragraph>
  </div>
)
